<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form (keydown.enter)="confirmDelete()" (ngSubmit)="confirmDelete()" class="dialog-form" name="deleteForm">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'entity.delete.title' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div
            [config]="preloaderService.getLoadingConfig(saleDeleteDialogKey)"
            [suiIsLoading]="saleDeleteDialogKey"
            class="siklu-mat-dialog-body dialog-body preloader-wrapper"
            matDialogContent
    >
        <ng-container *ngIf="!hasSaleCompanies; else selectContent">
            <winde-alert-error></winde-alert-error>
            <p>{{ 'userManagement.delete.question' | translate: {login: saleUser.login | gtthTextEscape} }}</p>
        </ng-container>

        <ng-template #selectContent>
            <ng-container *ngIf="successorCompaniesList$ | async as successorCompanies">
                <div *ngIf="successorCompanies.length > 0; else canNotReassign">
                    <div>
                        {{
                            'userManagement.delete.countOfSales'
                                | translate: {usernameAndCount: saleUser.login + ': ' + saleUser.saleCompaniesCount}
                        }}
                    </div>

                    <div class="sale-reassign-block">
                        <div>{{ 'userManagement.delete.selectTip' | translate }}</div>
                        <sui-select-component
                                *ngIf="saleSelectList"
                                [config]="saleSelectList"
                        ></sui-select-component>
                    </div>
                </div>
            </ng-container>
        </ng-template>

        <ng-template #canNotReassign>
            <winde-alert-error></winde-alert-error>
            <p>{{ 'userManagement.delete.warning' | translate }}</p>
        </ng-template>
    </div>

    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button *ngIf="!hasSaleCompanies || (hasSaleCompanies && this.saleSelectList && this.saleSelectList.value)" type="submit" windeRed>
            <sui-svg-icon icon="trash"/>
            {{ (hasSaleCompanies ? 'userManagement.delete.reassignAndDelete' : 'entity.action.delete') | translate }}
        </button>
    </div>
</form>
